import api from "@modules/api/api";
import { useQuery } from "@tanstack/react-query";
import DropOffLocation from "../types/DropOffLocation";
import dropOffLocationQueryKeys from "../dropOffLocationQueryKeys";

const getDropOffLocations = async (): Promise<DropOffLocation[]> => {
  return api.get<DropOffLocation[]>("api/drop-off-locations");
};

export default function useDropOffLocationsList() {
  const { data, error } = useQuery({
    queryKey: dropOffLocationQueryKeys.all,
    queryFn: getDropOffLocations,
  });

  return {
    dropOffLocations: data ?? [],
    isLoading: !error && !data,
    error,
  };
}
